<template>
    <BreadCrumb PageTitle="Liste des sessions" />
    <ListeSession />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeSession from "@/components/Session/ListeSession.vue";

  
  
  export default defineComponent({
    name: "ListeSessionPage",
    components: {
      BreadCrumb,
      ListeSession,
    },
  });
  </script>